import { render, staticRenderFns } from "./SectionBoxConfirm.vue?vue&type=template&id=d0f78ca6&scoped=true"
import script from "./SectionBoxConfirm.vue?vue&type=script&lang=js"
export * from "./SectionBoxConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f78ca6",
  null
  
)

export default component.exports